import {Model} from '@vuex-orm/core';

export class SubjectQuestion extends Model {
  static entity = 'subject_questions';

  static primaryKey = ['subjectId', 'questionId'];

  static fields() {
    return {
      subjectId: this.attr(null),
      questionId: this.attr(null),
    };
  }

  subjectId: string;
  questionId: string;
}
